// Modules
import React, { useCallback, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { Loading } from '@dasa-health/components-react'

// Application
import { useLoginHook } from 'hooks'
import { getQueryParamsValue } from 'utils'

// Components
import { LoadingContainer } from 'components/FullPageLoading/styles'
import { goToPage } from 'redesign/utils/goToPage'
import { defaultConfig } from 'modules/RemoteConfig/defaultConfig'
import { useRemoteConfig } from 'modules/RemoteConfig/hooks/useRemoteConfig'
import { ROUTES_PATH } from 'constants/routesPath'

import { SESSION_STORAGES_KEYS } from 'constants/sessionStorages'

export const UniqueAccess: React.VFC = () => {
    const location = useLocation()

    const { authenticateWithUniqueToken, verifyUser } = useLoginHook()
    const { getConfigByName, isFeatureEnabled } = useRemoteConfig()

    const newRedirectFlow = isFeatureEnabled('AUTH_NEW_REDIRECT_FLOW')

    const getUserData = useCallback(async () => {
        const uniqueToken: string | null = getQueryParamsValue(location, 'u') || null
        const uniqueTokenFlag: string | null = getQueryParamsValue(location, 'uniqueToken') || null

        const redirectToParam: string | undefined = getQueryParamsValue(location, 'redirectTo') || undefined
        const decodeRedirectToParam = decodeURIComponent(redirectToParam || '')
        if (uniqueToken) {
            await authenticateWithUniqueToken(uniqueToken.trim(), decodeRedirectToParam)
            return
        }
        if (!newRedirectFlow) {
            return goToPage(getConfigByName('AUTH_REDIRECT_LOGIN') || defaultConfig.strings.AUTH_REDIRECT_LOGIN)
        }

        if (redirectToParam?.startsWith('http') && uniqueTokenFlag === 'true') {
            const newUrl = new URL(redirectToParam)
            newUrl.searchParams.delete('uniqueToken')
            sessionStorage.setItem(SESSION_STORAGES_KEYS.REDIRECT_TO_URL, newUrl.toString())
            sessionStorage.setItem(SESSION_STORAGES_KEYS.UNIQUE_TOKEN, 'true')
            sessionStorage.setItem(SESSION_STORAGES_KEYS.UNIQUE_ACCESS, 'true')
            await verifyUser()
            return
        }

        goToPage(ROUTES_PATH.FORWARDING_APP)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        getUserData()
        // verifyQueryParamsAndSaveSessionStorage()
    }, [getUserData])

    return (
        <LoadingContainer aria-busy="true" aria-live="polite">
            <Loading />
        </LoadingContainer>
    )
}
